import { render } from "./SizeTypes.vue?vue&type=template&id=35f5f498"
import script from "./SizeTypes.vue?vue&type=script&lang=js"
export * from "./SizeTypes.vue?vue&type=script&lang=js"

import "./SizeTypes.vue?vue&type=style&index=0&id=35f5f498&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__